import { Component, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { settings } from '../../../app.settings';

@Component({
  selector: 'app-auth-form',
  templateUrl: './auth-form.component.html',
  styleUrls: ['./auth-form.component.sass']
})
export class AuthFormComponent implements OnInit {
  @Input() model: any = {};
  @Input() captcha = false;

  public form: NgForm;
  public captachKey = settings.keys.captcha;

  ngOnInit() {
  }

  onSubmit(form: NgForm) {
    this.form = form;
  }

  getPasswordAppUrl() {
    const url = settings.app.url?.replace('shift', 'password').replace('.eu', '.fr');

    // Tells the password app to send the user back here once the password is saved
    return url && url + '?origin=shift';
  }

  onCaptchaSuccess(token) {
    this.model.g_recaptcha = token;
  }
}
